<template>
  <transition name="contact-dialog-fade">
    <div
      v-if="value"
      class="contact-dialog"
      role="presentation"
      @click.self="closeDialog"
    >
      <section
        ref="dialogPanel"
        class="contact-dialog__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-dialog-title"
      >
        <header class="contact-dialog__header">
          <h2 id="contact-dialog-title" class="contact-dialog__title">联系我们</h2>
          <button
            ref="closeButton"
            class="contact-dialog__close-button"
            type="button"
            aria-label="关闭联系我们弹窗"
            @click="closeDialog"
          >
            <img
              class="contact-dialog__close-icon"
              src="@/assets/pages/contact/images/3ea57fd4b8bce2efdaf0a39bca24a709.png"
              alt=""
            />
          </button>
        </header>

        <div class="contact-dialog__divider" aria-hidden="true"></div>

        <div class="contact-dialog__sections">
          <article
            v-for="service in contactServices"
            :key="service.type"
            class="contact-dialog__section"
            :class="`contact-dialog__section--${service.type}`"
          >
            <h3
              class="contact-dialog__section-heading"
              :class="`contact-dialog__section-heading--${service.type}`"
            >
              {{ service.title }}
            </h3>

            <div class="contact-dialog__section-content">
              <p class="contact-dialog__audience-prompt">{{ service.audiencePrompt }}</p>

              <ul class="contact-dialog__service-options">
                <li
                  v-for="option in service.options"
                  :key="option"
                  class="contact-dialog__service-option"
                >
                  {{ option }}
                </li>
              </ul>

              <p class="contact-dialog__contact-prompt">请联系：</p>

              <div class="contact-dialog__contact-card">
                <div class="contact-dialog__contact-copy">
                  <strong class="contact-dialog__advisor-name">{{ service.advisorName }}</strong>
                  <p class="contact-dialog__contact-line">
                    手机号：
                    <span class="contact-dialog__phone-number">
                      {{ service.phoneNumber }}
                    </span>
                  </p>
                  <p class="contact-dialog__contact-line">工作日：9:00~18:00</p>
                </div>

                <div class="contact-dialog__wechat-card">
                  <img
                    class="contact-dialog__wechat-qr"
                    :src="service.wechatQrCode"
                    :alt="`${service.advisorName}微信二维码`"
                  />
                  <span class="contact-dialog__wechat-label">扫码添加微信</span>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ContactDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      previousBodyOverflow: '',
      previouslyFocusedElement: null,
      isPageScrollLocked: false,
      contactServices: [
        {
          type: 'product',
          title: '产品咨询',
          audiencePrompt: '如果您是家长/学生，想要：',
          options: ['产品咨询与预约', '大学服务咨询', '营地报名预约', '了解/加入聚星社区'],
          advisorName: '时老师',
          phoneNumber: '18525123266',
          wechatQrCode: require('@/assets/pages/contact/images/remote/2f88ffcaa082cea57fa93abb28a2e3ce.png')
        },
        {
          type: 'business',
          title: '商务合作',
          audiencePrompt: '如果您是机构/企业/高校，想要：',
          options: ['机构合作对接', '赋能聚星计划', '获得定向培养人才', '商务合作/洽谈'],
          advisorName: '刘老师',
          phoneNumber: '18640109087',
          wechatQrCode: require('@/assets/pages/contact/images/liu-teacher-wechat-qr.png')
        }
      ]
    }
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.openDialog()
      } else {
        this.restorePageState()
      }
    }
  },
  mounted() {
    if (this.value) this.openDialog()
  },
  beforeDestroy() {
    this.restorePageState()
  },
  methods: {
    openDialog() {
      if (this.isPageScrollLocked) return

      this.previouslyFocusedElement = document.activeElement
      this.previousBodyOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      this.isPageScrollLocked = true
      document.addEventListener('keydown', this.handleKeydown)

      this.$nextTick(() => {
        if (this.$refs.closeButton) this.$refs.closeButton.focus()
      })
    },
    closeDialog() {
      this.$emit('input', false)
    },
    handleKeydown(event) {
      if (event.key === 'Escape') this.closeDialog()
    },
    restorePageState() {
      if (!this.isPageScrollLocked) return

      document.body.style.overflow = this.previousBodyOverflow
      this.isPageScrollLocked = false
      document.removeEventListener('keydown', this.handleKeydown)

      if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus()
      }
      this.previouslyFocusedElement = null
    }
  }
}
</script>

<style scoped>
.contact-dialog {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 7px 5px;
  background: rgba(7, 7, 7, 0.6);
}

.contact-dialog__panel {
  width: 100%;
  max-width: 426px;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 14px 16px 16px;
  border-radius: 11px;
  background: #fff;
  box-sizing: border-box;
  overscroll-behavior: contain;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.contact-dialog__panel::-webkit-scrollbar {
  display: none;
}

.contact-dialog__header {
  display: flex;
  min-height: 41px;
  align-items: flex-start;
  justify-content: space-between;
}

.contact-dialog__title {
  margin: 0;
  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

.contact-dialog__close-button {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  margin: -2px -7px 0 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.contact-dialog__close-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.contact-dialog__divider {
  height: 1px;
  margin-bottom: 10px;
  background: #d4dae8;
}

.contact-dialog__sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-dialog__section {
  overflow: hidden;
  border-radius: 9px;
  background: #eaf0fa;
}

.contact-dialog__section-heading {
  display: flex;
  height: 40px;
  align-items: center;
  margin: 0;
  padding: 0 11px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}

.contact-dialog__section-heading--product {
  border-radius: 9px 9px 0 0;
  background: url('~@/assets/pages/about/images/c7b18bf2fc0b98175c284f9c39669fd7.png') center / cover no-repeat;
}

.contact-dialog__section--business {
  border-radius: 0 0 9px 9px;
}

.contact-dialog__section-heading--business {
  border: 1px dashed #999;
  border-radius: 0;
  background: url('~@/assets/pages/about/images/c04f18d2314f3f95356dc12620a441b6.png') center / cover no-repeat;
  box-sizing: border-box;
}

.contact-dialog__section-content {
  padding: 13px 11px;
}

.contact-dialog__audience-prompt,
.contact-dialog__contact-prompt,
.contact-dialog__contact-line {
  margin: 0;
}

.contact-dialog__audience-prompt,
.contact-dialog__contact-prompt {
  color: #333;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.contact-dialog__service-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 10px;
  margin: 8px 0;
  padding: 0;
  list-style: none;
}

.contact-dialog__service-option {
  display: flex;
  min-width: 0;
  min-height: 43px;
  align-items: center;
  padding: 8px 11px;
  border-radius: 7px;
  background: #fff;
  color: #333;
  font-size: 16px;
  line-height: 20px;
  box-sizing: border-box;
}

.contact-dialog__contact-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 90px;
  gap: 8px;
  min-height: 118px;
  align-items: center;
  margin-top: 9px;
  padding: 8px 8px 8px 11px;
  border-radius: 7px;
  background: #fff;
  box-sizing: border-box;
}

.contact-dialog__contact-copy {
  min-width: 0;
}

.contact-dialog__advisor-name {
  display: block;
  margin-bottom: 2px;
  color: #333;
  font-size: 17px;
  line-height: 24px;
}

.contact-dialog__contact-line {
  color: #333;
  font-size: 16px;
  line-height: 25px;
  white-space: nowrap;
}

.contact-dialog__phone-number {
  margin-left: 4px;
  color: #1b6aee;
  text-decoration: none;
}

.contact-dialog__wechat-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
}

.contact-dialog__wechat-qr {
  width: 86px;
  height: 86px;
  object-fit: contain;
}

.contact-dialog__wechat-label {
  margin-top: 2px;
  color: #666;
  font-size: 12px;
  line-height: 17px;
  white-space: nowrap;
}

.contact-dialog-fade-enter-active,
.contact-dialog-fade-leave-active {
  transition: opacity 0.18s ease;
}

.contact-dialog-fade-enter,
.contact-dialog-fade-leave-to {
  opacity: 0;
}

@media (max-width: 360px) {
  .contact-dialog__panel {
    padding-right: 13px;
    padding-left: 13px;
  }

  .contact-dialog__section-content {
    padding-right: 9px;
    padding-left: 9px;
  }

  .contact-dialog__service-options {
    gap: 7px;
  }

  .contact-dialog__service-option {
    padding-right: 8px;
    padding-left: 8px;
    font-size: 15px;
  }

  .contact-dialog__contact-card {
    grid-template-columns: minmax(0, 1fr) 78px;
    padding-left: 9px;
  }

  .contact-dialog__contact-line {
    font-size: 15px;
  }

  .contact-dialog__wechat-qr {
    width: 76px;
    height: 76px;
  }
}
</style>
